export const sampleData = {
  "constants": [
    {
      "EnName": "reports",
      "FaLabel": "گزارشات",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "createBackup",
      "FaLabel": "تهیه فایل پشتیبان",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "returnBackup",
      "FaLabel": "بازگرداندن فایل پشتیبان",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "userList",
      "FaLabel": "فهرست کاربران",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "programSettings",
      "FaLabel": "تنظیمات برنامه",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "eventsList",
      "FaLabel": "فهرست وقایع",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "showSum",
      "FaLabel": "نمایش جمع ها در فهرست",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "new",
      "FaLabel": "امکان جدید در فهرست",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "edit",
      "FaLabel": "امکان ویرایش در فهرست",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "delete",
      "FaLabel": "امکان حذف در فهرست",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    }
  ],
  "List": [
    {
      "EnName": "lx-ANBKALA",
      "FaLabel": "انبار کالا",
      "fields": [
        {
          "label": "کد موجودی",
          "value": "KODEKA"
        },
        {
          "label": "کد کالا",
          "value": "CKALA"
        },
        {
          "label": "نام کالا",
          "value": "NKALA"
        },
        {
          "label": "کد انبار",
          "value": "IDANBAR"
        },
        {
          "label": "عنوان انبار",
          "value": "ONVANBAR"
        },
        {
          "label": "کد گروه کالا",
          "value": "CODEGRKALA"
        },
        {
          "label": "نام گروه کالا",
          "value": "NGRKALA"
        },
        {
          "label": "کد سایز",
          "value": "KODESIZE"
        },
        {
          "label": "سایز",
          "value": "SIZE"
        },
        {
          "label": "کد رنگ",
          "value": "KODERANG"
        },
        {
          "label": "رنگ",
          "value": "RANG"
        },
        {
          "label": "تعداد ورودی",
          "value": "TEIN"
        },
        {
          "label": "تعداد خروجی",
          "value": "TEOUT"
        },
        {
          "label": "تعداد موجود",
          "value": "TEMOGOD"
        },
        {
          "label": "قیمت فروش",
          "value": "GHFOROSH"
        },
        {
          "label": "ارزش کالا",
          "value": "ARZESHKALA"
        },
        {
          "label": "جمع ارزش کالا",
          "value": "JAMARZKALA"
        },
        {
          "label": "ردیف",
          "value": "RADIF"
        },
        {
          "label": "لاین",
          "value": "LINE"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-DARCHEK",
      "FaLabel": "دریافت چک",
      "fields": [
        {
          "label": "کد دریافت چک",
          "value": "CDARCHEK"
        },
        {
          "label": "شماره چک",
          "value": "SHCHEK"
        },
        {
          "label": "تاریخ صدور",
          "value": "DDATE"
        },
        {
          "label": "تاریخ وصول",
          "value": "VOSOL"
        },
        {
          "label": "وضعیت وصول",
          "value": "VZVOSOL"
        },
        {
          "label": "مبلغ",
          "value": "MB"
        },
        {
          "label": "کد مشتری",
          "value": "CMOSH"
        },
        {
          "label": "مشخصه مشتری",
          "value": "MOMOSH"
        },
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHHBANK"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-DARHAVALE",
      "FaLabel": "دریافت حواله",
      "fields": [
        {
          "label": "کد دریافت حواله",
          "value": "CDARHAVA"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "کد مشتری",
          "value": "CMOSH"
        },
        {
          "label": "مشخصه مشتری",
          "value": "MOMOSH"
        },
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHHBANK"
        },
        {
          "label": "مبلغ",
          "value": "MB"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-DARVAJ",
      "FaLabel": "دریافت وجه نقد",
      "fields": [
        {
          "label": "کد دریافت وجه نقد",
          "value": "CDARVAJ"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "کد مشتری",
          "value": "CMOSH"
        },
        {
          "label": "مشخصه مشتری",
          "value": "MOMOSH"
        },
        {
          "label": "کد صندوق",
          "value": "CSANDOGH"
        },
        {
          "label": "مشخصه صندوق",
          "value": "MOSANDOGH"
        },
        {
          "label": "مبلغ",
          "value": "MB"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-FAKLOZBUE",
      "FaLabel": "فاکتور خرید کالا (جز)",
      "fields": [
        {
          "label": "کد فاکتور جز",
          "value": "CFAKJOZ"
        },
        {
          "label": "کد فاکتور خرید",
          "value": "CFAKKOL"
        },
        {
          "label": "شماره فاکتور",
          "value": "SHFAK"
        },
        {
          "label": "کد فروشنده",
          "value": "CSELLER"
        },
        {
          "label": "مشخصه فروشنده",
          "value": "MOSELLER"
        },
        {
          "label": "کد کالا",
          "value": "CKALA"
        },
        {
          "label": "نام کالا",
          "value": "NKALA"
        },
        {
          "label": "کد گروه کالا",
          "value": "CODEGRKALA"
        },
        {
          "label": "نام گروه کالا",
          "value": "NGRKALA"
        },
        {
          "label": "کد سایز",
          "value": "KODESIZE"
        },
        {
          "label": "سایز",
          "value": "SIZE"
        },
        {
          "label": "کد رنگ",
          "value": "KODERANG"
        },
        {
          "label": "رنگ",
          "value": "RANG"
        },
        {
          "label": "کد انبار",
          "value": "IDANBAR"
        },
        {
          "label": "عنوان انبار",
          "value": "ONVANBAR"
        },
        {
          "label": "تخفیف",
          "value": "OFFKALA"
        },
        {
          "label": "تعداد",
          "value": "TE"
        },
        {
          "label": "قیمت واحد",
          "value": "GHVAHED"
        },
        {
          "label": "جمع کل",
          "value": "JAM"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        },
        {
          "label": "کدزمان",
          "value": "CODEZAMAN"
        },
        {
          "label": "ساعت",
          "value": "SAAT"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-FAKJOZSELL",
      "FaLabel": "فاکتور فروش کالا(جز)",
      "fields": [
        {
          "label": "کد فاکتور جز",
          "value": "CFAKJOZ"
        },
        {
          "label": "کد فاکتور کل فروش",
          "value": "CFAKKOL"
        },
        {
          "label": "کد موجودی",
          "value": "KODEKA"
        },
        {
          "label": "کد کالا",
          "value": "CKALA"
        },
        {
          "label": "نام کالا",
          "value": "NKALA"
        },
        {
          "label": "کد گروه کالا",
          "value": "CODEGRKALA"
        },
        {
          "label": "نام گروه کالا",
          "value": "NGRKALA"
        },
        {
          "label": "کد سایز",
          "value": "KODESIZE"
        },
        {
          "label": "سایز",
          "value": "SIZE"
        },
        {
          "label": "کد رنگ",
          "value": "KODERANG"
        },
        {
          "label": "رنگ",
          "value": "RANG"
        },
        {
          "label": "ارزش کالا",
          "value": "ARZESHKALA"
        },
        {
          "label": "کد انبار",
          "value": "IDANBAR"
        },
        {
          "label": "عنوان انبار",
          "value": "ONVANBAR"
        },
        {
          "label": "قیمت واحد",
          "value": "GHVAHED"
        },
        {
          "label": "تخفیف",
          "value": "OFFKALA"
        },
        {
          "label": "جمع کل",
          "value": "JAM"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "کد مشتری",
          "value": "CMOSH"
        },
        {
          "label": "مشخصه مشتری",
          "value": "MOMOSH"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "تعداد",
          "value": "TE"
        },
        {
          "label": "نوع فاکتور",
          "value": "TYPFAK"
        },
        {
          "label": "وضعیت تراز",
          "value": "VZ_TZ"
        },
        {
          "label": "تاریخ تراز",
          "value": "DDATE_TZ"
        },
        {
          "label": "کاربر تراز کننده",
          "value": "KMO_TZ"
        },
        {
          "label": "سود نسبت به ارزش کالا",
          "value": "SODBEARZESH"
        },
        {
          "label": "جمع کل ارزش کالا",
          "value": "JAMKOLARZESH"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        },
        {
          "label": "کدزمان",
          "value": "CODEZAMAN"
        },
        {
          "label": "ساعت",
          "value": "SAAT"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        },
        {
          "label": "فلگ پرینت",
          "value": "PRINTFLAG"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-FAKKOLBUE",
      "FaLabel": "فاکتور خرید کالا (کل)",
      "fields": [
        {
          "label": "کد فاکتور خرید کل",
          "value": "CFAKKOL"
        },
        {
          "label": "شماره فاکتور",
          "value": "SHFAK"
        },
        {
          "label": "کد فروشنده",
          "value": "CSELLER"
        },
        {
          "label": "مشخصه فروشنده",
          "value": "MOSELLER"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "نوع پرداخت",
          "value": "TYPPAR"
        },
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHHBANK"
        },
        {
          "label": "کد صندوق",
          "value": "CSANDOGH"
        },
        {
          "label": "مشخصه صندوق",
          "value": "MOSANDOGH"
        },
        {
          "label": "جمع مبلغ خرید کالا",
          "value": "JAMKALA"
        },
        {
          "label": "مبلغ خدمات",
          "value": "MBSERVIC"
        },
        {
          "label": "عنوان خدمات",
          "value": "ONSERVIC"
        },
        {
          "label": "تخفیف",
          "value": "OFFKALA"
        },
        {
          "label": "درصد مالیات",
          "value": "MALIAT"
        },
        {
          "label": "مبلغ مالیات",
          "value": "MBMALIAT"
        },
        {
          "label": "جمع کالا و خدمات",
          "value": "JAMKOL"
        },
        {
          "label": "جمع تخفیف فاکتور جزء",
          "value": "TAKHFIFJOZ"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "جمع کل فاکتور",
          "value": "JAMKS"
        },
        {
          "label": "مبلغ نقدی",
          "value": "MBNAGHDI"
        },
        {
          "label": "مبلغ واریزی به بانک",
          "value": "MBBANK"
        },
        {
          "label": "ساعت",
          "value": "SAAT"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-FAKKOLSELL",
      "FaLabel": "فاکتور فروش کالا (کل)",
      "fields": [
        {
          "label": "کد فاکتور کل فروش",
          "value": "CFAKKOL"
        },
        {
          "label": "نوع فاکتور",
          "value": "TYPFAK"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "نوع دریافت",
          "value": "TYPDAR"
        },
        {
          "label": "کد مشتری",
          "value": "CMOSH"
        },
        {
          "label": "مشخصه مشتری",
          "value": "MOMOSH"
        },
        {
          "label": "جمع کالا",
          "value": "JAMKALA"
        },
        {
          "label": "جمع تخفیف فاکتور جزء",
          "value": "TAKHFIFJOZ"
        },
        {
          "label": "عنوان خدمات",
          "value": "ONSERVIC"
        },
        {
          "label": "مبلغ خدمات",
          "value": "MBSERVIC"
        },
        {
          "label": "تخفیف",
          "value": "OFFKALA"
        },
        {
          "label": "درصد مالیات",
          "value": "MALIAT"
        },
        {
          "label": "مبلغ مالیات",
          "value": "MBMALIAT"
        },
        {
          "label": "جمع کالا و خدمات",
          "value": "JAMKOL"
        },
        {
          "label": "جمع کل فاکتور",
          "value": "JAMKS"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        },
        {
          "label": "جمع کل تخفیف",
          "value": "JAMTAKHFIF"
        },
        {
          "label": "بستر فروش",
          "value": "BASTARFOROOSH"
        },
        {
          "label": "استان",
          "value": "OSTAN"
        },
        {
          "label": "شهر",
          "value": "SHAHR"
        },
        {
          "label": "کد سفارش",
          "value": "ORDER_ID"
        },
        {
          "label": "مبلغ نقدی",
          "value": "MBNAGHDI"
        },
        {
          "label": "مبلغ واریزی",
          "value": "MBBANK"
        },
        {
          "label": "وضعیت تراز کالا",
          "value": "VZ_TZ"
        },
        {
          "label": "سود نسبت به ارزش کالا",
          "value": "SODBEARZESH"
        },
        {
          "label": "جمع کل ارزش کالا",
          "value": "JAMKOLARZESH"
        },
        {
          "label": "مانده فاکتور",
          "value": "MANDE"
        },
        {
          "label": "وضعیت تراز مالی",
          "value": "VZ_TZ_MALI"
        },
        {
          "label": "ساعت",
          "value": "SAAT"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-GRHAZIN",
      "FaLabel": "گروه هزینه",
      "fields": [
        {
          "label": "کد گروه هزینه",
          "value": "KODEGRHAZINE"
        },
        {
          "label": "نام گروه هزینه",
          "value": "NGRHAZIN"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-GRKALA",
      "FaLabel": "گروه کالا",
      "fields": [
        {
          "label": "کد گروه کالا",
          "value": "CODEGRKALA"
        },
        {
          "label": "نام گروه کالا",
          "value": "NGRKALA"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-HAZIN",
      "FaLabel": "هزینه",
      "fields": [
        {
          "label": "کد هزینه",
          "value": "CHAZIN"
        },
        {
          "label": "کد گروه هزینه",
          "value": "KODEGRHAZINE"
        },
        {
          "label": "نام گروه هزینه",
          "value": "NGRHAZIN"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "نوع پرداخت",
          "value": "TYPPARDAKHT"
        },
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHHBANK"
        },
        {
          "label": "کد صندوق",
          "value": "CSANDOGH"
        },
        {
          "label": "مشخصه صندوق",
          "value": "MOSANDOGH"
        },
        {
          "label": "مبلغ",
          "value": "MB"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-HBANK",
      "FaLabel": "حساب بانکی",
      "fields": [
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "تاریخ صدور",
          "value": "DDATE"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHHBANK"
        },
        {
          "label": "نوع حساب",
          "value": "TYPH"
        },
        {
          "label": "مبلغ اول دوره",
          "value": "MBAVAL"
        },
        {
          "label": "وضعیت اتصال به فاکتور فروش",
          "value": "VAZEIATETESAL"
        },
        {
          "label": "اتصال به سایت",
          "value": "SITE"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-KALA",
      "FaLabel": "فهرست کالا",
      "fields": [
        {
          "label": "کد کالا",
          "value": "CKALA"
        },
        {
          "label": "نام کالا",
          "value": "NKALA"
        },
        {
          "label": "کد گروه کالا",
          "value": "CODEGRKALA"
        },
        {
          "label": "نام گروه کالا",
          "value": "NGRKALA"
        },
        {
          "label": "کد سایز",
          "value": "KODESIZE"
        },
        {
          "label": "سایز",
          "value": "SIZE"
        },
        {
          "label": "کد رنگ",
          "value": "KODERANG"
        },
        {
          "label": "رنگ",
          "value": "RANG"
        },
        {
          "label": "قیمت فروش",
          "value": "GHFOROSH"
        },
        {
          "label": "تخفیف",
          "value": "TAKHFIF"
        },
        {
          "label": "نوع سیستم انبارگردانی",
          "value": "NOEANBGARDANI"
        },
        {
          "label": "کد کالا در فروشگاه اینترنتی",
          "value": "KODEKALAINTERNETI"
        },
        {
          "label": "کد سری",
          "value": "CODESERI"
        },
        {
          "label": "درصد تخفیف",
          "value": "DARSADTAKHFIF"
        },
        {
          "label": "مبلغ تخفیف درصدی",
          "value": "MBTAKHFIFDAR"
        },
        {
          "label": "مبغ تخفیف ریالی",
          "value": "MBTAKHFIFRIAL"
        },
        {
          "label": "تخفیف کل",
          "value": "TAKHFIFKOL"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-MOSHTARE",
      "FaLabel": "مشتری",
      "fields": [
        {
          "label": "کد مشتری",
          "value": "CMOSH"
        },
        {
          "label": "مشخصه مشتری",
          "value": "MOMOSH"
        },
        {
          "label": "تاریخ ثبت",
          "value": "DDATE"
        },
        {
          "label": "موبایل",
          "value": "MOBILE"
        },
        {
          "label": "تلفن",
          "value": "TELPHON"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHHBANK"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        },
        {
          "label": "مانده اول دوره",
          "value": "MANDEAVAL"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-PARCHEK",
      "FaLabel": "پرداخت چک",
      "fields": [
        {
          "label": "کد پرداخت چک",
          "value": "CPARCHEK"
        },
        {
          "label": "شماره چک",
          "value": "SHCHEK"
        },
        {
          "label": "تاریخ صدور",
          "value": "DDATE"
        },
        {
          "label": "تاریخ وصول",
          "value": "VOSOL"
        },
        {
          "label": "وضعیت وصول",
          "value": "VZVOSOL"
        },
        {
          "label": "مبلغ",
          "value": "MB"
        },
        {
          "label": "کد فروشنده",
          "value": "CSELLER"
        },
        {
          "label": "مشخصه فروشنده",
          "value": "MOSELLER"
        },
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHHBANK"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-PARHAVALE",
      "FaLabel": "پرداخت حواله",
      "fields": [
        {
          "label": "کد پرداخت حواله",
          "value": "CPARHAVA"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "طرف پرداخت حواله",
          "value": "NOEPARHAVALE"
        },
        {
          "label": "کد فروشنده",
          "value": "CSELLER"
        },
        {
          "label": "مشخصه فروشنده",
          "value": "MOSELLER"
        },
        {
          "label": "کد مشتری",
          "value": "CMOSH"
        },
        {
          "label": "مشخصه مشتری",
          "value": "MOMOSH"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHKART"
        },
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHHBANK"
        },
        {
          "label": "مبلغ",
          "value": "MB"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-PARVAJ",
      "FaLabel": "پرداخت وجه نقد",
      "fields": [
        {
          "label": "کد پرداخت وجه نقد",
          "value": "CPARVAJ"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "طرف پرداخت وجه",
          "value": "NOEPARVAJ"
        },
        {
          "label": "کد فروشنده",
          "value": "CSELLER"
        },
        {
          "label": "مشخصه فروشنده",
          "value": "MOSELLER"
        },
        {
          "label": "کد مشتری",
          "value": "CMOSH"
        },
        {
          "label": "مشخصه مشتری",
          "value": "MOMOSH"
        },
        {
          "label": "کد صندوق",
          "value": "CSANDOGH"
        },
        {
          "label": "مشخصه صندوق",
          "value": "MOSANDOGH"
        },
        {
          "label": "مبلغ",
          "value": "MB"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-SANDOGH",
      "FaLabel": "صندوق",
      "fields": [
        {
          "label": "کد صندوق",
          "value": "CSANDOGH"
        },
        {
          "label": "مشخصه صندوق",
          "value": "MOSANDOGH"
        },
        {
          "label": "تاریخ ثبت",
          "value": "DDATE"
        },
        {
          "label": "مبلغ اول دوره",
          "value": "MBAVAL"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-SELLER",
      "FaLabel": "فروشنده",
      "fields": [
        {
          "label": "کد فروشنده",
          "value": "CSELLER"
        },
        {
          "label": "تاریخ ثبت",
          "value": "DDATE"
        },
        {
          "label": "مشخصه فروشنده",
          "value": "MOSELLER"
        },
        {
          "label": "کد اقتصادی/ملی",
          "value": "CMELI"
        },
        {
          "label": "موبایل",
          "value": "MOBILE"
        },
        {
          "label": "تلفن",
          "value": "TELPHON"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHKART"
        },
        {
          "label": "بدهی اول دوره",
          "value": "BEDEHI"
        },
        {
          "label": "آدرس",
          "value": "ADRES"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-RANG",
      "FaLabel": "رنگ",
      "fields": [
        {
          "label": "کد رنگ",
          "value": "KODERANG"
        },
        {
          "label": "رنگ",
          "value": "RANG"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-SIZE",
      "FaLabel": "سایز",
      "fields": [
        {
          "label": "کد سایز",
          "value": "KODESIZE"
        },
        {
          "label": "سایز",
          "value": "SIZE"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-MAKHZANANBAR",
      "FaLabel": "مخزن ورودی انبار",
      "fields": [
        {
          "label": "کد مخزن انبار",
          "value": "IDMAKHZAN"
        },
        {
          "label": "کد کالا",
          "value": "CKALA"
        },
        {
          "label": "نام کالا",
          "value": "NKALA"
        },
        {
          "label": "نوع موجودی",
          "value": "NOEMOJODI"
        },
        {
          "label": "کد موجودی اولیه",
          "value": "IDMOJODIAVAL"
        },
        {
          "label": "کد فاکتور خرید کل",
          "value": "CFAKKOL"
        },
        {
          "label": "کد فاکتور خرید جزء",
          "value": "CFAKJOZ"
        },
        {
          "label": "کد فروشنده",
          "value": "CSELLER"
        },
        {
          "label": "مشخصه فروشنده",
          "value": "MOSELLER"
        },
        {
          "label": "کد مرجوع از فروش کل",
          "value": "CMRJAZFOROSHKOL"
        },
        {
          "label": "کد مرجوع از فروش جزء",
          "value": "CMRJAZFOROSHJOZ"
        },
        {
          "label": "تعداد ورودی",
          "value": "TEVOROD"
        },
        {
          "label": "نوع سیستم انبارگردانی",
          "value": "NOEANBGARDANI"
        },
        {
          "label": "قیمت خرید",
          "value": "FI"
        },
        {
          "label": "تعداد خروجی",
          "value": "TEKHOROJ"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "ساعت",
          "value": "SAAT"
        },
        {
          "label": "موجودی",
          "value": "MOJODI"
        },
        {
          "label": "ارزش",
          "value": "ARZESH"
        },
        {
          "label": "جمع کل",
          "value": "JAMKOL"
        },
        {
          "label": "کد انبار",
          "value": "IDANBAR"
        },
        {
          "label": "عنوان انبار",
          "value": "ONVANBAR"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        },
        {
          "label": "کدزمان",
          "value": "CODEZAMAN"
        },
        {
          "label": "کد گروه کالا",
          "value": "CODEGRKALA"
        },
        {
          "label": "نام گروه کالا",
          "value": "NGRKALA"
        },
        {
          "label": "کد رنگ",
          "value": "KODERANG"
        },
        {
          "label": "رنگ",
          "value": "RANG"
        },
        {
          "label": "کد سایز",
          "value": "KODESIZE"
        },
        {
          "label": "سایز",
          "value": "SIZE"
        },
        {
          "label": "کد حواله انبار",
          "value": "CHAVALEANBAR"
        },
        {
          "label": "زیان حاصل از مرجوع",
          "value": "ZARAR"
        },
        {
          "label": "کد سری حواله",
          "value": "CODESERIHAVALE"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-MOJODIAVAL",
      "FaLabel": "موجودی اولیه",
      "fields": [
        {
          "label": "کد موجودی اولیه",
          "value": "IDMOJODIAVAL"
        },
        {
          "label": "کد کالا",
          "value": "CKALA"
        },
        {
          "label": "نام کالا",
          "value": "NKALA"
        },
        {
          "label": "کد گروه کالا",
          "value": "CODEGRKALA"
        },
        {
          "label": "نام گروه کالا",
          "value": "NGRKALA"
        },
        {
          "label": "کد سایز",
          "value": "KODESIZE"
        },
        {
          "label": "سایز",
          "value": "SIZE"
        },
        {
          "label": "کد رنگ",
          "value": "KODERANG"
        },
        {
          "label": "رنگ",
          "value": "RANG"
        },
        {
          "label": "کد انبار",
          "value": "IDANBAR"
        },
        {
          "label": "عنوان انبار",
          "value": "ONVANBAR"
        },
        {
          "label": "تعداد",
          "value": "TE"
        },
        {
          "label": "مبلغ خرید",
          "value": "FI"
        },
        {
          "label": "جمع کل",
          "value": "JAMKOL"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "ساعت",
          "value": "SAAT"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-LISTANBAR",
      "FaLabel": "لیست انبار",
      "fields": [
        {
          "label": "کد انبار",
          "value": "IDANBAR"
        },
        {
          "label": "عنوان انبار",
          "value": "ONVANBAR"
        },
        {
          "label": "مجموع تعداد کالا",
          "value": "TE"
        },
        {
          "label": "مجموع ارزش کالا",
          "value": "MBARZESH"
        },
        {
          "label": "وضعیت اتصال به سایت",
          "value": "SITE"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-ENTVAJBTOB",
      "FaLabel": "انتقال وجه بانک به بانک",
      "fields": [
        {
          "label": "کد انتقال وجه",
          "value": "IDENTEGHAL"
        },
        {
          "label": "تاریخ انتقال",
          "value": "DDATE"
        },
        {
          "label": "ساعت",
          "value": "SAAT"
        },
        {
          "label": "کد حساب بانکی مبدا",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک مبدا",
          "value": "NBANK"
        },
        {
          "label": "کد بانک مقصد",
          "value": "CHBANKBE"
        },
        {
          "label": "نام بانک مقصد",
          "value": "NBANKBE"
        },
        {
          "label": "مبلغ انتقال",
          "value": "MABLAGH"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-ENTVAJSTOS",
      "FaLabel": "انتقال وجه صندوق به صندوق",
      "fields": [
        {
          "label": "کد انتقال وجه",
          "value": "IDENTEGHAL"
        },
        {
          "label": "تاریخ انتقال",
          "value": "DDATE"
        },
        {
          "label": "ساعت",
          "value": "SAAT"
        },
        {
          "label": "کد صندوق مبدا",
          "value": "CSANDOGH"
        },
        {
          "label": "نام صندوق مبدا",
          "value": "MOSANDOGH"
        },
        {
          "label": "کد صندوق مقصد",
          "value": "CSANDOGHBE"
        },
        {
          "label": "نام صندوق مقصد",
          "value": "MOSANDOGHBE"
        },
        {
          "label": "مبلغ انتقال",
          "value": "MABLAGH"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-ENTVAJBTOS",
      "FaLabel": "انتقال وجه بانک به صندوق",
      "fields": [
        {
          "label": "کد انتقال وجه",
          "value": "IDENTEGHAL"
        },
        {
          "label": "تاریخ انتقال",
          "value": "DDATE"
        },
        {
          "label": "ساعت",
          "value": "SAAT"
        },
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "کد صندوق",
          "value": "CSANDOGH"
        },
        {
          "label": "مشخصه صندوق",
          "value": "MOSANDOGH"
        },
        {
          "label": "مبلغ انتقال",
          "value": "MABLAGH"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-ENTVAJSTOB",
      "FaLabel": "انتقال وجه صندوق به بانک",
      "fields": [
        {
          "label": "کد انتقال وجه",
          "value": "IDENTEGHAL"
        },
        {
          "label": "تاریخ انتقال",
          "value": "DDATE"
        },
        {
          "label": "ساعت",
          "value": "SAAT"
        },
        {
          "label": "کد صندوق",
          "value": "CSANDOGH"
        },
        {
          "label": "مشخصه صندوق",
          "value": "MOSANDOGH"
        },
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "مبلغ انتقال",
          "value": "MABLAGH"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-BARSANDOGH",
      "FaLabel": "فهرست بررسی صندوق",
      "fields": [
        {
          "label": "کد بررسی صندوق",
          "value": "CBARSANDOGH"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        },
        {
          "label": "نوع تراز",
          "value": "NOETARAZ"
        },
        {
          "label": "کد بستن صندوق",
          "value": "CBASTANSANDOGH"
        },
        {
          "label": "کد پرسنل",
          "value": "CPERSONEL"
        },
        {
          "label": "نام و نام خانوادگی",
          "value": "NAME"
        },
        {
          "label": "مبلغ اعلام شده",
          "value": "MBELAM"
        },
        {
          "label": "مبلغ پس از بررسی",
          "value": "MBBARRASI"
        },
        {
          "label": "مبلغ کسر یا مازاد",
          "value": "MBKASRYAMAZAD"
        },
        {
          "label": "وضعیت بررسی",
          "value": "VZBAR"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-HAVALEANBAR",
      "FaLabel": "حواله انبار",
      "fields": [
        {
          "label": "کد حواله انبار",
          "value": "CHAVALEANBAR"
        },
        {
          "label": "کد سری",
          "value": "CODESERI"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "کد موجودی",
          "value": "KODEKA"
        },
        {
          "label": "کد کالا",
          "value": "CKALA"
        },
        {
          "label": "نام کالا",
          "value": "NKALA"
        },
        {
          "label": "کد گروه کالا",
          "value": "CODEGRKALA"
        },
        {
          "label": "نام گروه کالا",
          "value": "NGRKALA"
        },
        {
          "label": "کد رنگ",
          "value": "KODERANG"
        },
        {
          "label": "رنگ",
          "value": "RANG"
        },
        {
          "label": "کد سایز",
          "value": "KODESIZE"
        },
        {
          "label": "سایز",
          "value": "SIZE"
        },
        {
          "label": "کد انبار مبدا",
          "value": "IDANBAR"
        },
        {
          "label": "عنوان انبار مبدا",
          "value": "ONVANBAR"
        },
        {
          "label": "کد انبار مقصد",
          "value": "IDANBARBE"
        },
        {
          "label": "عنوان انبار مقصد",
          "value": "ONVANBARBE"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        },
        {
          "label": "تعداد",
          "value": "TE"
        },
        {
          "label": "ساعت",
          "value": "SAAT"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-PERSONEL",
      "FaLabel": "پرسنل",
      "fields": [
        {
          "label": "کد پرسنل",
          "value": "CPERSONEL"
        },
        {
          "label": "نام و نام خانوادگی",
          "value": "NAME"
        },
        {
          "label": "کد ملی",
          "value": "CMELI"
        },
        {
          "label": "موبایل",
          "value": "MOBILE"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHKART"
        },
        {
          "label": "شماره شبا",
          "value": "SHSHABA"
        },
        {
          "label": "نوع کاربر",
          "value": "NOEKARBAR"
        },
        {
          "label": "پایه حقوق (روزانه)",
          "value": "PAYEHOGHOGH"
        },
        {
          "label": "درصد بیمه سهم کارگر",
          "value": "DARBIMKARGAR"
        },
        {
          "label": "درصد بیمه سهم کارفرما",
          "value": "DARBIMKARFARMA"
        },
        {
          "label": "حق مسکن",
          "value": "HAGHMASKAN"
        },
        {
          "label": "بن کارگری",
          "value": "BONKAR"
        },
        {
          "label": "حق اولاد",
          "value": "HAGHOLAD"
        },
        {
          "label": "سنوات",
          "value": "SANAVAT"
        },
        {
          "label": "ضریب اضافه کار",
          "value": "ZARIBEZAFEKAR"
        },
        {
          "label": "کد صندوق",
          "value": "CSANDOGH"
        },
        {
          "label": "مشخصه صندوق",
          "value": "MOSANDOGH"
        },
        {
          "label": "دسترسی انبار",
          "value": "DASTANBAR"
        },
        {
          "label": "کد انبار",
          "value": "IDANBAR"
        },
        {
          "label": "عنوان انبار",
          "value": "ONVANBAR"
        },
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "امکان اعمال تخفیف روی فاکتور فروش",
          "value": "DASTAKHFIF"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-HOZORGHIAB",
      "FaLabel": "ساعت حضور و غیاب",
      "fields": [
        {
          "label": "کد حضور و غیاب",
          "value": "IDHOZOR"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "کد پرسنل",
          "value": "CPERSONEL"
        },
        {
          "label": "نام و نام خانوادگی",
          "value": "NAME"
        },
        {
          "label": "ساعت ورود",
          "value": "SAATVOROD"
        },
        {
          "label": "ساعت خروج",
          "value": "SAATKHOROJ"
        },
        {
          "label": "مدت زمان حضور به دقیقه",
          "value": "ZAMANHOZOR"
        },
        {
          "label": "میزان اضافه کار به ساعت",
          "value": "EZAFEKAR"
        },
        {
          "label": "ضریب اضافه کار",
          "value": "ZARIBEZAFEKAR"
        },
        {
          "label": "مبلغ اضافه کار",
          "value": "MBEZAFEKAR"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-BASTANSANDOGH",
      "FaLabel": "فهرست بستن صندوق",
      "fields": [
        {
          "label": "کد بستن صندوق",
          "value": "CBASTANSANDOGH"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        },
        {
          "label": "کد کاربر صندوق",
          "value": "CPERSONEL"
        },
        {
          "label": "مشخصه کاربر صندوق",
          "value": "NAME"
        },
        {
          "label": "مبلغ اعلام شده",
          "value": "MBELAM"
        },
        {
          "label": "نوع تراز",
          "value": "NOETARAZ"
        },
        {
          "label": "نوع واریزی",
          "value": "NOEVARIZI"
        },
        {
          "label": "کد صندوق",
          "value": "CSANDOGH"
        },
        {
          "label": "مشخصه صندوق",
          "value": "MOSANDOGH"
        },
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "وضعیت بررسی",
          "value": "VZBAR"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-ANBARGARDANI",
      "FaLabel": "انبارگردانی",
      "fields": [
        {
          "label": "کد انبارگردانی",
          "value": "IDANBGARDANI"
        },
        {
          "label": "کد موجودی",
          "value": "KODEKA"
        },
        {
          "label": "کد کالا",
          "value": "CKALA"
        },
        {
          "label": "نام کالا",
          "value": "NKALA"
        },
        {
          "label": "کد گروه کالا",
          "value": "CODEGRKALA"
        },
        {
          "label": "نام گروه کالا",
          "value": "NGRKALA"
        },
        {
          "label": "کد سایز",
          "value": "KODESIZE"
        },
        {
          "label": "سایز",
          "value": "SIZE"
        },
        {
          "label": "کد رنگ",
          "value": "KODERANG"
        },
        {
          "label": "رنگ",
          "value": "RANG"
        },
        {
          "label": "ارزش کالا",
          "value": "ARZESHKALA"
        },
        {
          "label": "تعداد",
          "value": "TE"
        },
        {
          "label": "نوع تراز",
          "value": "NOE"
        },
        {
          "label": "مبلغ کسر",
          "value": "MBKASR"
        },
        {
          "label": "مبلغ اضافه",
          "value": "MBEZAFEKAR"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-PARDAKHTFAK",
      "FaLabel": "پرداخت فاکتور فروش",
      "fields": [
        {
          "label": "کد پرداخت",
          "value": "IDPAR"
        },
        {
          "label": "کد فاکتور کل فروش",
          "value": "CFAKKOL"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        },
        {
          "label": "مبلغ",
          "value": "MB"
        },
        {
          "label": "نوع پرداخت",
          "value": "NOPAR"
        },
        {
          "label": "کد صندوق",
          "value": "CSANDOGH"
        },
        {
          "label": "مشخصه صندوق",
          "value": "MOSANDOGH"
        },
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "کدینگ حسابداری",
          "value": "CODING_CODE"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-MRJAZFOROSHKOL",
      "FaLabel": "مرجوع از فروش کل",
      "fields": [
        {
          "label": "کد مرجوع از فروش کل",
          "value": "CMRJAZFOROSHKOL"
        },
        {
          "label": "کد مشتری",
          "value": "CMOSH"
        },
        {
          "label": "مشخصه مشتری",
          "value": "MOMOSH"
        },
        {
          "label": "تاریخ مرجوعی",
          "value": "DDATE"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        },
        {
          "label": "جمع مرجوعی",
          "value": "JAMMRJ"
        },
        {
          "label": "علت مرجوعی",
          "value": "TZ"
        },
        {
          "label": "کد فاکتور کل فروش",
          "value": "CFAKKOL"
        },
        {
          "label": "درصد مالیات",
          "value": "MALIAT"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        },
        {
          "label": "مبلغ مالیات",
          "value": "MBMALIAT"
        },
        {
          "label": "جمع کل ارزش کالا",
          "value": "JAMKOLARZESH"
        },
        {
          "label": "سود نسبت به ارزش کالا",
          "value": "SODBEARZESH"
        },
        {
          "label": "جمع کل",
          "value": "JAMKOL"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-MRJAZFOROSHJOZ",
      "FaLabel": "مرجوع از فروش جزء",
      "fields": [
        {
          "label": "کد مرجوع از فروش جزء",
          "value": "CMRJAZFOROSHJOZ"
        },
        {
          "label": "کد مرجوع از فروش کل",
          "value": "CMRJAZFOROSHKOL"
        },
        {
          "label": "کد مشتری",
          "value": "CMOSH"
        },
        {
          "label": "مشخصه مشتری",
          "value": "MOMOSH"
        },
        {
          "label": "تاریخ مرجوعی",
          "value": "DDATE"
        },
        {
          "label": "کد فاکتور جز",
          "value": "CFAKJOZ"
        },
        {
          "label": "کد کالا",
          "value": "CKALA"
        },
        {
          "label": "نام کالا",
          "value": "NKALA"
        },
        {
          "label": "کد گروه کالا",
          "value": "CODEGRKALA"
        },
        {
          "label": "نام گروه کالا",
          "value": "NGRKALA"
        },
        {
          "label": "کد رنگ",
          "value": "KODERANG"
        },
        {
          "label": "رنگ",
          "value": "RANG"
        },
        {
          "label": "کد سایز",
          "value": "KODESIZE"
        },
        {
          "label": "سایز",
          "value": "SIZE"
        },
        {
          "label": "قیمت فروش",
          "value": "GHFOROSH"
        },
        {
          "label": "تعداد مرجوعی",
          "value": "TE"
        },
        {
          "label": "کد انبار",
          "value": "IDANBAR"
        },
        {
          "label": "عنوان انبار",
          "value": "ONVANBAR"
        },
        {
          "label": "ارزش کالا",
          "value": "ARZESHKALA"
        },
        {
          "label": "جمع کل ارزش کالا",
          "value": "JAMKOLARZESH"
        },
        {
          "label": "سود نسبت به ارزش کالا",
          "value": "SODBEARZESH"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-MRJAZBUYKOL",
      "FaLabel": "مرجوع از خرید کل",
      "fields": [
        {
          "label": "کد مرجوع از خرید کل",
          "value": "CMRJAZBUYKOL"
        },
        {
          "label": "کد فروشنده",
          "value": "CSELLER"
        },
        {
          "label": "مشخصه فروشنده",
          "value": "MOSELLER"
        },
        {
          "label": "تاریخ مرجوعی",
          "value": "DDATE"
        },
        {
          "label": "ساعت",
          "value": "SAAT"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        },
        {
          "label": "جمع مرجوعی",
          "value": "JAMMRJ"
        },
        {
          "label": "کد فاکتور کل خرید",
          "value": "CFAKKOL"
        },
        {
          "label": "درصد مالیات",
          "value": "MALIAT"
        },
        {
          "label": "مبلغ مالیات",
          "value": "MBMALIAT"
        },
        {
          "label": "جمع کل",
          "value": "JAMKOL"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        },
        {
          "label": "علت مرجوعی",
          "value": "TZ"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-KHOROJIMAKHZAN",
      "FaLabel": "مخزن خروجی انبار",
      "fields": [
        {
          "label": "کد خروجی مخزن",
          "value": "IDKHOMAKHZAN"
        },
        {
          "label": "کد کالا",
          "value": "CKALA"
        },
        {
          "label": "نام کالا",
          "value": "NKALA"
        },
        {
          "label": "تعداد",
          "value": "TE"
        },
        {
          "label": "کد فاکتور کل فروش",
          "value": "CFAKKOL"
        },
        {
          "label": "کد فاکتور جز",
          "value": "CFAKJOZ"
        },
        {
          "label": "قیمت فروش",
          "value": "GHFOROSH"
        },
        {
          "label": "قیمت خرید",
          "value": "FI"
        },
        {
          "label": "ارزش کالا",
          "value": "ARZESH"
        },
        {
          "label": "سود نسبت به قیمت خرید",
          "value": "SODBEFI"
        },
        {
          "label": "سود نسبت به ارزش کالا",
          "value": "SODBEARZESH"
        },
        {
          "label": "کد مخزن انبار",
          "value": "IDMAKHZAN"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "ساعت",
          "value": "SAAT"
        },
        {
          "label": "سال",
          "value": "SAL"
        },
        {
          "label": "ماه",
          "value": "MAH"
        },
        {
          "label": "روز",
          "value": "ROOZ"
        },
        {
          "label": "جمع کل ارزش کالا",
          "value": "JAMKOLARZESH"
        },
        {
          "label": "کد گروه کالا",
          "value": "CODEGRKALA"
        },
        {
          "label": "نام گروه کالا",
          "value": "NGRKALA"
        },
        {
          "label": "کد رنگ",
          "value": "KODERANG"
        },
        {
          "label": "رنگ",
          "value": "RANG"
        },
        {
          "label": "کد سایز",
          "value": "KODESIZE"
        },
        {
          "label": "سایز",
          "value": "SIZE"
        },
        {
          "label": "کد انبار",
          "value": "IDANBAR"
        },
        {
          "label": "عنوان انبار",
          "value": "ONVANBAR"
        },
        {
          "label": "نوع خروجی",
          "value": "NOEKHOROJI"
        },
        {
          "label": "کد حواله انبار",
          "value": "CHAVALEANBAR"
        },
        {
          "label": "کد مرجوع از خرید کل",
          "value": "CMRJAZBUYKOL"
        },
        {
          "label": "کد مرجوع از خرید جز",
          "value": "CMRJAZBUYJOZ"
        },
        {
          "label": "کد سری حواله",
          "value": "CODESERIHAVALE"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-KAMPKOL",
      "FaLabel": "کمپین تبلیغاتی کل",
      "fields": [
        {
          "label": "کد کمپین کل",
          "value": "IDKAMPKOL"
        },
        {
          "label": "عنوان کمپین تنبلیغاتی",
          "value": "ONVKAMP"
        },
        {
          "label": "تاریخ شروع کمپین",
          "value": "DDATESHORO"
        },
        {
          "label": "ساعت شروع کمپین",
          "value": "SAATSHORO"
        },
        {
          "label": "تاریخ پایان کمپین",
          "value": "DDATEPAYAN"
        },
        {
          "label": "ساعت پایان کمپین",
          "value": "SAATPAYAN"
        },
        {
          "label": "مدت زمان کمپین",
          "value": "MODATKAMP"
        },
        {
          "label": "وضعیت کمپین",
          "value": "VZKAMP"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "lx-MRJAZBUYJOZ",
      "FaLabel": "مرجوع از خرید جز",
      "fields": [
        {
          "label": "کد مرجوع از خرید جز",
          "value": "CMRJAZBUYJOZ"
        },
        {
          "label": "کد مرجوع از خرید کل",
          "value": "CMRJAZBUYKOL"
        },
        {
          "label": "کد فروشنده",
          "value": "CSELLER"
        },
        {
          "label": "مشخصه فروشنده",
          "value": "MOSELLER"
        },
        {
          "label": "تاریخ مرجوعی",
          "value": "DDATE"
        },
        {
          "label": "کد فاکتور خرید جز",
          "value": "CFAKJOZ"
        },
        {
          "label": "کد کالا",
          "value": "CKALA"
        },
        {
          "label": "نام کالا",
          "value": "NKALA"
        },
        {
          "label": "کد گروه کالا",
          "value": "CODEGRKALA"
        },
        {
          "label": "نام گروه کالا",
          "value": "NGRKALA"
        },
        {
          "label": "کد سایز",
          "value": "KODESIZE"
        },
        {
          "label": "سایز",
          "value": "SIZE"
        },
        {
          "label": "کد رنگ",
          "value": "KODERANG"
        },
        {
          "label": "رنگ",
          "value": "RANG"
        },
        {
          "label": "قیمت خرید",
          "value": "GHVAHED"
        },
        {
          "label": "تعداد مرجوعی",
          "value": "TE"
        },
        {
          "label": "کد انبار",
          "value": "IDANBAR"
        },
        {
          "label": "عنوان انبار",
          "value": "ONVANBAR"
        },
        {
          "label": "جمع کل",
          "value": "JAMKOL"
        },
        {
          "label": "مشخصه کاربر",
          "value": "KMO"
        }
      ],
      "exceptionFields": [],
      "value": 1
    }
  ],
  "operation": [
    {
      "EnName": "oi-DARCHEK",
      "FaLabel": "دریافت چک",
      "fields": [
        {
          "label": "تاریخ وصول",
          "value": "VOSOL"
        },
        {
          "label": "مشخصه مشتری",
          "value": "MOMOSH"
        },
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHHBANK"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-DARHAVALE",
      "FaLabel": "دریافت حواله",
      "fields": [
        {
          "label": "مشخصه مشتری",
          "value": "MOMOSH"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHHBANK"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-DARVAJ",
      "FaLabel": "دریافت وجه نقد",
      "fields": [
        {
          "label": "کد مشتری",
          "value": "CMOSH"
        },
        {
          "label": "مشخصه مشتری",
          "value": "MOMOSH"
        },
        {
          "label": "کد صندوق",
          "value": "CSANDOGH"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-GRHAZIN",
      "FaLabel": "گروه هزینه",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-GRKALA",
      "FaLabel": "گروه کالا",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-HAZIN",
      "FaLabel": "هزینه",
      "fields": [
        {
          "label": "نوع پرداخت",
          "value": "TYPPARDAKHT"
        },
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHHBANK"
        },
        {
          "label": "کد صندوق",
          "value": "CSANDOGH"
        },
        {
          "label": "مشخصه صندوق",
          "value": "MOSANDOGH"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        },
        {
          "label": "سال و ماه",
          "value": "MAHSAL"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-HBANK",
      "FaLabel": "حساب بانکی",
      "fields": [
        {
          "label": "تاریخ صدور",
          "value": "DDATE"
        },
        {
          "label": "نوع حساب",
          "value": "TYPH"
        },
        {
          "label": "اتصال به سایت",
          "value": "SITE"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-KALA",
      "FaLabel": "کالا",
      "fields": [
        {
          "label": "کد کالا در فروشگاه اینترنتی",
          "value": "KODEKALAINTERNETI"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-MOSHTARE",
      "FaLabel": "مشتری",
      "fields": [
        {
          "label": "تاریخ ثبت",
          "value": "DDATE"
        },
        {
          "label": "موبایل",
          "value": "MOBILE"
        },
        {
          "label": "تلفن",
          "value": "TELPHON"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHHBANK"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        },
        {
          "label": "مانده اول دوره",
          "value": "MANDEAVAL"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-PARCHEK",
      "FaLabel": "پرداخت چک",
      "fields": [
        {
          "label": "مشخصه فروشنده",
          "value": "MOSELLER"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHHBANK"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-PARHAVALE",
      "FaLabel": "پرداخت حواله",
      "fields": [
        {
          "label": "کد فروشنده",
          "value": "CSELLER"
        },
        {
          "label": "مشخصه فروشنده",
          "value": "MOSELLER"
        },
        {
          "label": "کد مشتری",
          "value": "CMOSH"
        },
        {
          "label": "مشخصه مشتری",
          "value": "MOMOSH"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHKART"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHHBANK"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-PARVAJ",
      "FaLabel": "پرداخت وجه نقد",
      "fields": [
        {
          "label": "طرف پرداخت وجه",
          "value": "NOEPARVAJ"
        },
        {
          "label": "کد فروشنده",
          "value": "CSELLER"
        },
        {
          "label": "مشخصه فروشنده",
          "value": "MOSELLER"
        },
        {
          "label": "کد مشتری",
          "value": "CMOSH"
        },
        {
          "label": "مشخصه مشتری",
          "value": "MOMOSH"
        },
        {
          "label": "کد صندوق",
          "value": "CSANDOGH"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-SANDOGH",
      "FaLabel": "صندوق",
      "fields": [
        {
          "label": "تاریخ ثبت",
          "value": "DDATE"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-SELLER",
      "FaLabel": "فروشنده",
      "fields": [
        {
          "label": "تاریخ ثبت",
          "value": "DDATE"
        },
        {
          "label": "کد اقتصادی/ملی",
          "value": "CMELI"
        },
        {
          "label": "موبایل",
          "value": "MOBILE"
        },
        {
          "label": "تلفن",
          "value": "TELPHON"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHKART"
        },
        {
          "label": "بدهی اول دوره",
          "value": "BEDEHI"
        },
        {
          "label": "آدرس",
          "value": "ADRES"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-RANG",
      "FaLabel": "رنگ",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-SIZE",
      "FaLabel": "سایز",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-MAKHZANANBAR",
      "FaLabel": "مخزن ورودی انبار",
      "fields": [
        {
          "label": "ساعت",
          "value": "SAAT"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-MOJODIAVAL",
      "FaLabel": "موجودی اولیه",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-LISTANBAR",
      "FaLabel": "تعریف انبار",
      "fields": [
        {
          "label": "وضعیت اتصال به سایت",
          "value": "SITE"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-ENTVAJBTOB",
      "FaLabel": "انتقال وجه بانک به بانک",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-ENTVAJSTOS",
      "FaLabel": "انتقال وجه صندوق به صندوق",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-ENTVAJBTOS",
      "FaLabel": "انتقال وجه بانک به صندوق",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-ENTVAJSTOB",
      "FaLabel": "انتقال وجه صندوق به بانک",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-BARSANDOGH",
      "FaLabel": "بررسی صندوق",
      "fields": [
        {
          "label": "وضعیت بررسی",
          "value": "VZBAR"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-HAVALEANBAR",
      "FaLabel": "حواله انبار",
      "fields": [
        {
          "label": "ساعت",
          "value": "SAAT"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-PERSONEL",
      "FaLabel": "پرسنل",
      "fields": [
        {
          "label": "کد ملی",
          "value": "CMELI"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHKART"
        },
        {
          "label": "شماره شبا",
          "value": "SHSHABA"
        },
        {
          "label": "نوع کاربر",
          "value": "NOEKARBAR"
        },
        {
          "label": "پایه حقوق (روزانه)",
          "value": "PAYEHOGHOGH"
        },
        {
          "label": "درصد بیمه سهم کارگر",
          "value": "DARBIMKARGAR"
        },
        {
          "label": "درصد بیمه سهم کارفرما",
          "value": "DARBIMKARFARMA"
        },
        {
          "label": "حق مسکن",
          "value": "HAGHMASKAN"
        },
        {
          "label": "بن کارگری",
          "value": "BONKAR"
        },
        {
          "label": "حق اولاد",
          "value": "HAGHOLAD"
        },
        {
          "label": "سنوات",
          "value": "SANAVAT"
        },
        {
          "label": "ضریب اضافه کار",
          "value": "ZARIBEZAFEKAR"
        },
        {
          "label": "کد صندوق",
          "value": "CSANDOGH"
        },
        {
          "label": "مشخصه صندوق",
          "value": "MOSANDOGH"
        },
        {
          "label": "دسترسی انبار",
          "value": "DASTANBAR"
        },
        {
          "label": "کد انبار",
          "value": "IDANBAR"
        },
        {
          "label": "عنوان انبار",
          "value": "ONVANBAR"
        },
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "امکان اعمال تخفیف روی فاکتور فروش",
          "value": "DASTAKHFIF"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-HOZORGHIAB",
      "FaLabel": "ساعت حضور و غیاب",
      "fields": [
        {
          "label": "تاریخ",
          "value": "DDATE"
        },
        {
          "label": "کد پرسنل",
          "value": "CPERSONEL"
        },
        {
          "label": "نام و نام خانوادگی",
          "value": "NAME"
        },
        {
          "label": "ساعت ورود",
          "value": "SAATVOROD"
        },
        {
          "label": "ساعت خروج",
          "value": "SAATKHOROJ"
        },
        {
          "label": "میزان اضافه کار به ساعت",
          "value": "EZAFEKAR"
        },
        {
          "label": "ضریب اضافه کار",
          "value": "ZARIBEZAFEKAR"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-BARSANDOGH",
      "FaLabel": "بررسی صندوق",
      "fields": [
        {
          "label": "وضعیت بررسی",
          "value": "VZBAR"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-BASTANSANDOGH",
      "FaLabel": "بستن صندوق",
      "fields": [
        {
          "label": "کد صندوق",
          "value": "CSANDOGH"
        },
        {
          "label": "مشخصه صندوق",
          "value": "MOSANDOGH"
        },
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "وضعیت بررسی",
          "value": "VZBAR"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-ANBARGARDANI",
      "FaLabel": "انبارگردانی",
      "fields": [
        {
          "label": "ارزش کالا",
          "value": "ARZESHKALA"
        },
        {
          "label": "تعداد",
          "value": "TE"
        },
        {
          "label": "نوع تراز",
          "value": "NOE"
        },
        {
          "label": "تاریخ",
          "value": "DDATE"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-PARDAKHTFAK",
      "FaLabel": "پرداخت فاکتور فروش",
      "fields": [
        {
          "label": "کد صندوق",
          "value": "CSANDOGH"
        },
        {
          "label": "مشخصه صندوق",
          "value": "MOSANDOGH"
        },
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-MRJAZFOROSHKOL",
      "FaLabel": "مرجوع از فروش کل",
      "fields": [
        {
          "label": "علت مرجوعی",
          "value": "TZ"
        },
        {
          "label": "کد فاکتور کل فروش",
          "value": "CFAKKOL"
        },
        {
          "label": "درصد مالیات",
          "value": "MALIAT"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-MRJAZFOROSHJOZ",
      "FaLabel": "مرجوع از فروش جزء",
      "fields": [
        {
          "label": "کد فاکتور جز",
          "value": "CFAKJOZ"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-MRJAZBUYKOL",
      "FaLabel": "مرجوع از خرید کل",
      "fields": [
        {
          "label": "ساعت",
          "value": "SAAT"
        },
        {
          "label": "درصد مالیات",
          "value": "MALIAT"
        },
        {
          "label": "علت مرجوعی",
          "value": "TZ"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-MRJAZBUYJOZ",
      "FaLabel": "مرجوع از خرید جز",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-KHOROJIMAKHZAN",
      "FaLabel": "مخزن خروجی انبار",
      "fields": [
        {
          "label": "ساعت",
          "value": "SAAT"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-KAMPKOL",
      "FaLabel": "کمپین تبلیغاتی کل",
      "fields": [],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-FAKBUE",
      "FaLabel": "فاکتور خرید کالا",
      "fields": [
        {
          "label": "کد فروشنده",
          "value": "CSELLER"
        },
        {
          "label": "مشخصه فروشنده",
          "value": "MOSELLER"
        },
        {
          "label": "کد حساب بانکی",
          "value": "CHBANK"
        },
        {
          "label": "نام بانک",
          "value": "NBANK"
        },
        {
          "label": "شماره حساب/کارت",
          "value": "SHHBANK"
        },
        {
          "label": "کد صندوق",
          "value": "CSANDOGH"
        },
        {
          "label": "مشخصه صندوق",
          "value": "MOSANDOGH"
        },
        {
          "label": "مبلغ خدمات",
          "value": "MBSERVIC"
        },
        {
          "label": "عنوان خدمات",
          "value": "ONSERVIC"
        },
        {
          "label": "درصد مالیات",
          "value": "MALIAT"
        },
        {
          "label": "سال و ماه",
          "value": "MAHSAL"
        },
        {
          "label": "مبلغ نقدی",
          "value": "MBNAGHDI"
        },
        {
          "label": "مبلغ واریزی به بانک",
          "value": "MBBANK"
        },
        {
          "label": "شماره فاکتور",
          "value": "SHFAK"
        },
        {
          "label": "کد فروشنده",
          "value": "CSELLER"
        },
        {
          "label": "مشخصه فروشنده",
          "value": "MOSELLER"
        },
        {
          "label": "تخفیف",
          "value": "OFFKALA"
        }
      ],
      "exceptionFields": [],
      "value": 1
    },
    {
      "EnName": "oi-FAKSELL",
      "FaLabel": "فاکتور فروش کالا",
      "fields": [
        {
          "label": "کد مشتری",
          "value": "CMOSH"
        },
        {
          "label": "مشخصه مشتری",
          "value": "MOMOSH"
        },
        {
          "label": "عنوان خدمات",
          "value": "ONSERVIC"
        },
        {
          "label": "مبلغ خدمات",
          "value": "MBSERVIC"
        },
        {
          "label": "درصد مالیات",
          "value": "MALIAT"
        },
        {
          "label": "توضیحات",
          "value": "TZ"
        },
        {
          "label": "سال و ماه",
          "value": "MAHSAL"
        },
        {
          "label": "استان",
          "value": "OSTAN"
        },
        {
          "label": "شهر",
          "value": "SHAHR"
        },
        {
          "label": "کد سفارش",
          "value": "ORDER_ID"
        },
        {
          "label": "ساعت",
          "value": "SAAT"
        },
        {
          "label": "کد انبار",
          "value": "IDANBAR"
        },
        {
          "label": "عنوان انبار",
          "value": "ONVANBAR"
        },
        {
          "label": "تخفیف",
          "value": "OFFKALA"
        },
        {
          "label": "ساعت",
          "value": "SAAT"
        }
      ],
      "exceptionFields": [],
      "value": 1
    }
  ]
}